import React from 'react';
import { motion } from 'framer-motion';

export function AnalysisHeader() {
  return (
    <motion.div 
      className="text-center max-w-3xl mx-auto"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <h2 className="text-3xl font-bold mb-4">
        Your Website Copy Analysis
      </h2>
      <p className="text-lg text-gray-600">
        We've analyzed your website and identified key areas for improvement. 
        Here are the most critical issues affecting your conversion rates:
      </p>
    </motion.div>
  );
}